import { FontStyles } from "./styles/GlobalStyledComponents";
import { theme } from "./styles/Theme";
import { ThemeProvider } from "styled-components";
import "./styles/fontStyles.scss";
import AppRoutes from "./routes";
import { BrowserRouter as Router } from "react-router-dom";
import { useEffect, useRef } from "react";
import { initializeClarity } from "./services/Clarity";
import { clarity } from "react-microsoft-clarity";
declare global {
  interface Window {
    clarity: (method: string, options?: Record<string, any>) => void;
  }
}
const App = () => {
  const initialized = useRef(false);

  const getCookie = (cookieName: string) => {
    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    const targetCookie = cookies.find((cookie) =>
      cookie.startsWith(`${cookieName}=`)
    );
    return targetCookie ? targetCookie.split("=")[1] : null;
  };

  const checkCookieConsent = () => {
    const consentCookie = getCookie("CookieInformationConsent");
    let accepted = true;

    if (consentCookie) {
      try {
        const decodedConsent = decodeURIComponent(consentCookie);
        const consentData = JSON.parse(decodedConsent);

        // Verificar si hay cookies rechazadas
        const consentsDenied = consentData.consents_denied || [];
        accepted = consentsDenied.length === 0;
      } catch (error) {
        accepted = true; // Si hay un error, asumimos que las cookies están aceptadas
      }
    }
    if (!accepted) {
      configureClarity("denied", "denied");
    } else {
      configureClarity("granted", "granted");
    }
  };
  const configureClarity = (adStorage: string, analyticsStorage: string) => {
    if (typeof window !== "undefined" && typeof window.clarity === "function") {
      window.clarity("consentv2", {
        ad_Storage: adStorage,
        analytics_Storage: analyticsStorage,
      });
      // Comprobamos si ha arrancado Clarity antes de lanzar el consent
      if (clarity.hasStarted()) {
        clarity.consent();
      }
    }
  };


  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      initializeClarity();
    }
    checkCookieConsent();
  }, []);



  return (
    <>
      <Router>
        <ThemeProvider theme={theme}>
          <FontStyles />
          <AppRoutes />
        </ThemeProvider>
      </Router>
    </>
  );
};

export default App;


